export const state = {
    files: null,
}; 